import styles from "./style.module.scss";
import { PLACE_HOLDER_IMAGE_PATH } from "@lib/sharedUtils";
import { GQLOffers } from "@gql/types/gql";
import OfferLinks from "@components/shared/offerLinks";
import Image from "next/legacy/image";
export default function VendorOffer({
    buyer,
    categoryId,
}: {
    buyer: GQLOffers;
    categoryId: number;
}) {
    return (
        <>
            <div
                className={`${styles["backGroundColor"]} my-10 flex flex-col sm:flex-row justify-between items-center py-3  sm:px-4 px-6 rounded-lg`}
            >
                <span className={`relative block ${styles["topBuyerImage"]} `}>
                    {buyer.logo?.fullPath ? (
                        <div className="w-[120px] h-[95px] relative">
                            <Image
                                src={buyer.logo?.fullPath}
                                alt={buyer?.title ?? "logo"}
                                layout="fill"
                                objectFit="contain"
                            />
                        </div>
                    ) : (
                        <>
                            <img
                                src={PLACE_HOLDER_IMAGE_PATH}
                                alt="logo"
                                width={150}
                                height={40}
                            />
                        </>
                    )}
                </span>
                <div className="  sm:w-[29%] w-full  mt-2 sm:mt-0">
                    <OfferLinks
                        vendor={buyer}
                        categoryId={categoryId}
                        classNameButton={styles["linkButtonStyle"]}
                        removeExtraMargin={true}
                    />
                </div>
            </div>
        </>
    );
}
